export default "__VITE_ASSET__B4vzvM_r__"